/**
 * Organization statuses that clear the default operational route and
 * navigation lock.
 */
export const UNLOCKED_ORG_STATUSES: ReadonlySet<string> = new Set([
  "approved",
  "active",
]);

/**
 * Statuses that may access the Coaches and Staff setup surfaces (#1785).
 * This mirrors the backend's `_STAFF_MANAGEMENT_ALLOWED_STATUSES`: operators
 * may build their team during onboarding, while rejected, suspended, and
 * unknown organizations remain locked.
 */
export const STAFF_SETUP_ALLOWED_STATUSES: ReadonlySet<string> = new Set([
  "pending",
  "in_review",
  "approved",
  "active",
]);

/** Facility's court-inventory write policy; this does not unlock operations. */
export const COURT_SETUP_ALLOWED_STATUSES: ReadonlySet<string> = new Set([
  "pending",
  "in_review",
  "approved",
  "active",
]);
